export default "__VITE_ASSET__OuMnm_Ry__"